import createReducer from "utils/createReducer";
import {
    fromJS
} from 'immutable';
import {
    ApplicationTypes,
    BetHistoryTypes
} from "actions/types";

// Read from the build stamp in index.html rather than from placeholders substituted into this
// bundle. Update/index.js compares `buildno` against a freshly fetched version.json; when the
// value was stamped into the hashed bundle, a stale cached copy carried an old buildno, so the
// comparison never matched and the "New Version Available" prompt could not be dismissed —
// its Refresh button just reloads and re-fetches the same cached bundle.
//
// The placeholders remain the fallback so local dev and unit tests behave exactly as before.
const build = (typeof window !== "undefined" && window.__BUILD__) || {}

export const defaultValue = fromJS({
    showMenu: false,
    showSearch: false,
    showGameHistory: false,
    showBetHistory: false,
    version: build.version || "$INSERT_VERSION",
    buildno: build.buildno || "$INSERT_BUILD_NO"
})

export const application = createReducer(defaultValue,{
    [ApplicationTypes.SET_MENU_VISIBILITY](state, { payload }) {
        let newState = state.setIn(['showMenu'], payload)
        return newState
    },
    [ApplicationTypes.SET_SEARCH_VISIBILITY](state, { payload }) {
        let newState = state.setIn(['showSearch'], payload)
        return newState
    },
    [ApplicationTypes.SET_GAME_HISTORY_VISIBILITY](state, { payload }) {
        let newState = state.setIn(['showGameHistory'], payload)
        return newState
    },
    [BetHistoryTypes.SHOW_BET_HISTORY](state, { payload }) {
        let newState = state.setIn(['showBetHistory'], payload)
        return newState;
    },
    [BetHistoryTypes.HIDE_BET_HISTORY](state, {payload}) {
        let newState = state.setIn(['showBetHistory'], payload)
        return newState;
    },
    [ApplicationTypes.GET_MENU](state, {payload}) {
        let newState = state.setIn(['showMenu'], payload.get('expand'))
        return newState;
    }
})